export const RoutesConfig = {
  // Builder & Custom Models
  Builder: {
    path: 'builder/:id',
    fullPath: '/builder/:id',
  },

  CustomModels: {
    path: 'custom-model',
    fullPath: '/custom-model',
  },
  SingleCustomModel: {
    path: 'custom-model/:id',
    fullPath: '/custom-model/:id',
  },

  // Dealer Panel
  DealerPanelModels: {
    path: 'dp-models',
    fullPath: '/dp-models',
  },

  // Shared
  Profile: {
    path: 'profile',
    fullPath: '/profile',
  },
  Configure: {
    path: 'configure',
    fullPath: '/configure',
  },
  Bom: {
    path: 'bom',
    fullPath: '/bom',
  },
  Specs: {
    path: 'specs',
    fullPath: '/specs',
  },
  Users: {
    path: 'users',
    fullPath: '/users',
  },
  CompanyManagement: {
    path: 'company-management',
    fullPath: '/company-management',
  },

  // Supplier
  MyModels: {
    path: 'my-models',
    fullPath: '/my-models',
  },
  MyModelsSingle: {
    path: 'my-model/:id',
    fullPath: '/my-model/:id',
  },
  SupplierOrders: {
    path: 'supplier-orders',
    fullPath: '/supplier-orders',
  },
  SupplierSingleOrder: {
    path: 'supplier-order/:id',
    fullPath: '/supplier-order/:id',
  },
  SupplierNewOrder: {
    path: 'supplier-new-order',
    fullPath: '/supplier-new-order',
  },
  Buyers: {
    path: 'buyers',
    fullPath: '/buyers',
  },
  BuyersSingle: {
    path: 'buyers/:id',
    fullPath: '/buyers/:id',
  },

  // Buyer
  BuyerOrders: {
    path: 'buyer-orders',
    fullPath: '/buyer-orders',
  },
  BuyerSingleOrder: {
    path: 'buyer-order/:id',
    fullPath: '/buyer-order/:id',
  },
  BuyerNewOrder: {
    path: 'buyer-new-order',
    fullPath: '/buyer-new-order',
  },
  Suppliers: {
    path: 'suppliers',
    fullPath: '/suppliers',
  },

  // Buyer Quotations
  BuyerQuotations: {
    path: 'buyer-quotations',
    fullPath: '/buyer-quotations',
  },
  BuyerSingleQuotation: {
    path: 'buyer-quotations/:id',
    fullPath: '/buyer-quotations/:id',
  },
  BuyerNewQuotation: {
    path: 'buyer-new-quotation',
    fullPath: '/buyer-new-quotation',
  },
  BuyerNewOrderFromQuotation: {
    path: 'buyer-quotations/:id/create-order',
    fullPath: '/buyer-quotations/:id/create-order',
  },

  // Auth
  Login: {
    path: '/auth/login',
    fullPath: '/auth/login',
  },
  Register: {
    path: '/auth/register',
    fullPath: '/auth/register',
  },
  SuccessfulRegistration: {
    path: '/auth/successful-registration',
    fullPath: '/auth/successful-registration',
  },
  ResetPassword: {
    path: '/auth/reset-password',
    fullPath: '/auth/reset-password',
  },
  RequestPasswordResetPage: {
    path: '/auth/request-password-reset',
    fullPath: '/auth/request-password-reset',
  },

  // Company Login
  CompanyLogin: {
    path: '/company-login',
    fullPath: '/company-login',
    buildPath: (token: string, lang: string, companyName: string) =>
      `/company-login?token=${token}&lang=${lang}&companyName=${encodeURIComponent(
        companyName
      )}`,
  },
  CompanyLoginCreate: {
    path: '/company-login/create',
    fullPath: '/company-login/create',
    buildPath: (
      token: string,
      lang: string,
      companyName: string,
      userId?: string
    ) =>
      `/company-login/create?token=${token}&lang=${lang}&companyName=${encodeURIComponent(
        companyName
      )}${userId ? `&userId=${userId}` : ''}`,
  },
  CompanyLoginSelect: {
    path: '/company-login/select',
    fullPath: '/company-login/select',
    buildPath: (
      token: string,
      lang: string,
      companyName: string,
      userId: string
    ) =>
      `/company-login/select?token=${token}&lang=${lang}&companyName=${encodeURIComponent(
        companyName
      )}&userId=${userId}`,
  },
  CompanyLoginDetails: {
    path: '/company-login/details',
    fullPath: '/company-login/details',
    buildPath: (
      token: string,
      lang: string,
      companyName: string,
      userId: string
    ) =>
      `/company-login/details?token=${token}&lang=${lang}&companyName=${encodeURIComponent(
        companyName
      )}&userId=${userId}`,
  },
};
